import { IConfig } from '@unleash/proxy-client-react';

import packageJson from '../../package.json';

export const unleashConfig: IConfig = {
  url: window.env.UNLEASH_PROXY_URL,
  clientKey: window.env.UNLEASH_CLIENT_KEY,
  refreshInterval: window.env.UNLEASH_REFRESH_INTERVAL,
  appName: packageJson.name,
  environment: window.env.ENVIRONMENT,
};
